module.exports = __webpack_public_path__ + "static/media/perito_b.dddfd6b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/perito_b.png
// module id = 1161
// module chunks = 0